(() => {
  const body = document.body;
  const cartDrawer = document.querySelector("[data-cart-drawer]");
  const cartItems = document.querySelector("[data-cart-items]");
  const cartCount = document.querySelector("[data-cart-count]");
  const cartSubtotal = document.querySelector("[data-cart-subtotal]");

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
    } catch (_) {
      return `R$ ${(cents / 100).toFixed(2).replace(".", ",")}`;
    }
  };

  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("aria-hidden", "false");
    body.style.overflow = "hidden";
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("aria-hidden", "true");
    body.style.overflow = "";
  };

  const renderCart = (cart) => {
    if (cartCount) cartCount.textContent = cart.item_count;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (!cartItems) return;

    if (!cart.items.length) {
      cartItems.innerHTML = `
        <div class="empty-state">
          <h3>Sua sacola está vazia.</h3>
          <p>Explore peças selecionadas para encontrar uma escolha com presença.</p>
          <a class="button button--primary" href="/collections/novidades">Ver novidades</a>
        </div>`;
      return;
    }

    cartItems.innerHTML = cart.items.map((item) => `
      <div class="drawer-cart-item" data-line-item="${item.key}">
        <a href="${item.url}" class="drawer-cart-item__media">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ""}
        </a>
        <div class="drawer-cart-item__body">
          <a href="${item.url}">${item.product_title}</a>
          ${item.variant_title ? `<p>${item.variant_title}</p>` : ""}
          <p>${formatMoney(item.final_line_price)}</p>
          <div class="drawer-cart-item__quantity">
            <input type="number" min="0" value="${item.quantity}" data-cart-quantity data-key="${item.key}" aria-label="Quantidade de ${item.product_title}">
            <button type="button" data-cart-remove data-key="${item.key}">Remover</button>
          </div>
        </div>
      </div>`).join("");
  };

  const fetchCart = async () => {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("cart");
    return response.json();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error("change");
    renderCart(await response.json());
  };

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-open]")) openCart();
    if (event.target.closest("[data-cart-close]")) closeCart();

    const remove = event.target.closest("[data-cart-remove]");
    if (remove) changeLine(remove.dataset.key, 0).catch(() => window.location.assign("/cart"));

    const menuToggle = event.target.closest("[data-menu-toggle]");
    if (menuToggle) {
      const nav = document.querySelector("[data-main-navigation]");
      const expanded = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!expanded));
      nav?.classList.toggle("is-open", !expanded);
    }

    if (event.target.closest("[data-menu-close]")) {
      document.querySelector("[data-main-navigation]")?.classList.remove("is-open");
      document.querySelector("[data-menu-toggle]")?.setAttribute("aria-expanded", "false");
    }

    if (event.target.closest("[data-filter-open]")) document.querySelector("[data-facets]")?.classList.add("is-open");
    if (event.target.closest("[data-filter-close]")) document.querySelector("[data-facets]")?.classList.remove("is-open");
  });

  document.addEventListener("change", (event) => {
    const input = event.target.closest("[data-cart-quantity]");
    if (input) changeLine(input.dataset.key, Number(input.value)).catch(() => window.location.assign("/cart"));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCart();
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        });
        if (!response.ok) throw new Error("add");
        renderCart(await fetchCart());
        openCart();
      } catch (_) {
        form.submit();
      }
    });
  });
})();
